import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetUser } from '../services/Users/GetUser';
import { GetUserInfoInterface } from '../types/getUserInfoInterface';

export const useUserInfoStore = defineStore('userInfo', () => {
  const userInfo = ref<GetUserInfoInterface>({
    id: null,
    userName: '',
    firstName: '',
    lastName: '',
    profileImageUrl: '',
    defaultProfileImageUrl: '',
    dashboardType: null,
    employeeStatus: null,
    securityGroupId: null, // AccessLevelId
    hasInsight: false,
    hasPulse: false,
    hasAnything: false,
    isOrgChartVisible: false,
    biometricId: null,
    companyId: null,
  });

  const getUser = async () => {
    const response = await GetUser();

    userInfo.value = response;
  };
  const getUserResponse = async () => {
    const response = await GetUser();

    return response;
  };

  return {
    userInfo,
    getUser,
    getUserResponse,
  };
});
